module.exports = __webpack_public_path__ + "static/media/03_05_09.695624a9.png";